import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["open"]
const _hoisted_2 = {
  key: 0,
  class: "config-price-brackets__title-bracket"
}
const _hoisted_3 = { class: "config-price-brackets__title-price-container" }
const _hoisted_4 = ["open"]
const _hoisted_5 = { class: "config-price-brackets__content-title" }
const _hoisted_6 = { class: "config-price-brackets__titles" }
const _hoisted_7 = { class: "config-price-brackets__price-table-head-quantity" }
const _hoisted_8 = {
  key: 0,
  class: "config-price-brackets__price-table-head-parts"
}
const _hoisted_9 = {
  key: 1,
  class: "config-price-brackets__price-table-head-parts"
}
const _hoisted_10 = {
  key: 0,
  class: "config-price-brackets__brackets-container"
}
const _hoisted_11 = { class: "config-price-brackets__bracket-range" }
const _hoisted_12 = { class: "config-price-brackets__bracket-price" }
const _hoisted_13 = { class: "config-price-brackets__general-info" }
const _hoisted_14 = { class: "config-price-brackets__decoration-info" }

import { ref, computed, inject, watch } from 'vue';

import { inputFocusKey, configuratorStateKey } from '../ProductConfiguratorKeys';
import useContext from '@/composables/useContext';
import useWebsiteTexts from '@/composables/useWebsiteTexts';
import ConfiguratorChevron from '../ConfiguratorChevron.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfiguratorPriceBrackets',
  props: {
  product: {
    type: Object,
    required: true,
  },
  hasDecoration: {
    type: Boolean,
    required: true,
  },
},
  setup(__props) {

const { channel, cart, getCurrencySymbol, formatPrice } = useContext();
const { configuratorState, updateActivePriceBrackets } = inject(configuratorStateKey);
const { websiteText } = useWebsiteTexts();
const { inputFocus } = inject(inputFocusKey);
const toggleState = ref(false);

if (typeof window !== 'undefined') {
  toggleState.value = JSON.parse(localStorage.getItem("configurator:bracket-accordion-open-state") || 'false');
}

const props = __props;

const productPriceBrackets = computed(() => {
  const locale = channel.value?.locale;
  const currency = cart.value.currency?.id;

  if (!locale || !currency) {
    return [];
  }

  
  const brackets = props.product.prices;
  if (!brackets) return [];

  const bracketsWithoutDuplicates = brackets.reduce((acc, bracket) => {
    if (acc.every(a => a.price !== bracket.price)) {
      acc.push(bracket);
    }
    return acc;
  }, []);

  const { length } = bracketsWithoutDuplicates;
  return bracketsWithoutDuplicates.map((b, idx: number) => {
    const next = idx + 1;
    const bracketText = length <= next
      ? bracketNameText(b.bracket)
      : bracketNameText(`${b.bracket}-${bracketsWithoutDuplicates[next].bracket - 1}`);

    let matchingIndex = idx;
    const variantPrices = configuratorState.value.selections.selectedTechniqueVariantPrices;
    if (!variantPrices[matchingIndex]) {
      matchingIndex = variantPrices.length && variantPrices.length - 1;
    }
    const decoPrice = variantPrices[matchingIndex]?.price || 0;
    const decoPriceText = props.hasDecoration ? ` (+${formatPrice(decoPrice, undefined, '', '', 'decimal')})` : '';
    const priceText = bracketPriceText(`${formatPrice(b.price, undefined, '', '', 'decimal')}` + decoPriceText);
    const selectedPriceText = bracketPriceText(`${formatPrice(b.price + decoPrice, undefined, '', '', 'decimal')}`);
    return {
      bracketName: b.bracket,
      bracketText,
      priceText,
      selectedPriceText,
      price: b.price,
      decorationPrice: decoPrice,
    };
  });
});

const activeBracket = computed(() => {
  if (productPriceBrackets.value.length < 1) {
    return undefined;
  }
  const sum = configuratorState.value.sumQuantity;
  return Array.from(productPriceBrackets.value)
              .sort((a, b) => b.bracketName - a.bracketName)
              .find(b => b.bracketName <= sum)
    || productPriceBrackets.value[0];
});

function bracketNameText(name: string) {
  return `${name} ${websiteText('productdetailspage_printpieceabbreviated').value}`;
}

function bracketPriceText(price: number) {
  return `${price} ${getCurrencySymbol()}/${websiteText('productdetailspage_printpieceabbreviated').value}`;
}

function updateToggle() {
  toggleState.value = !toggleState.value;
  localStorage.setItem("configurator:bracket-accordion-open-state", JSON.stringify(toggleState.value));
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "config-price-brackets",
    open: toggleState.value
  }, [
    _createElementVNode("div", {
      tabindex: "0",
      class: "config-price-brackets__summary",
      onKeypress: _cache[0] || (_cache[0] = _withKeys(_withModifiers(($event: any) => (updateToggle()), ["prevent"]), ["space"])),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (updateToggle()))
    }, [
      (activeBracket.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(activeBracket.value.bracketText), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (activeBracket.value)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: _normalizeClass(['config-price-brackets__title-price',
          {'config-price-brackets__title-price--highlighted': _unref(inputFocus)}])
            }, _toDisplayString(activeBracket.value.selectedPriceText), 3))
          : _createCommentVNode("", true),
        _createVNode(ConfiguratorChevron, { open: toggleState.value }, null, 8, ["open"])
      ])
    ], 32),
    _createElementVNode("div", {
      open: toggleState.value,
      class: "config-price-brackets__content"
    }, [
      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(websiteText)('decoration__price_bracket').value), 1),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(websiteText)('common__quantity').value), 1),
        (__props.hasDecoration)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(websiteText)('configurator__product_decoration').value), 1))
          : _createCommentVNode("", true),
        (!__props.hasDecoration)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(websiteText)('configurator__product_no_decoration').value), 1))
          : _createCommentVNode("", true)
      ]),
      ((productPriceBrackets.value.length > 0))
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productPriceBrackets.value, (bracket) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(['config-price-brackets__bracket', {
            'config-price-brackets__bracket--active'
            : bracket.bracketName === activeBracket.value?.bracketName}]),
                key: bracket
              }, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(bracket.bracketText), 1),
                _createElementVNode("div", _hoisted_12, _toDisplayString(bracket.priceText), 1)
              ], 2))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(websiteText)('configurator__bracket_info').value), 1),
      _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(websiteText)('configurator__bracket_decoration_info').value), 1)
    ], 8, _hoisted_4)
  ], 8, _hoisted_1))
}
}

})